/*  
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs a').click(function(){
  
     $('.panel').hide();
     $('.tabs a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     $(panel).fadeIn(1000);
     
     return false;  // prevents link action
    
  });  // end click 

     $('.tabs li:first a').click();
     
}); // end ready
*/
  


document.addEventListener('DOMContentLoaded', function () {
    // Add event listeners to all the tabs
    const tabs = document.querySelectorAll('.tabs a');
    const panels = document.querySelectorAll('.panel');

    tabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default link behavior

            // Hide all panels
            panels.forEach(function (panel) {
                panel.style.display = 'none';
            });

            // Remove the active class from all tabs
            tabs.forEach(function (tab) {
                tab.classList.remove('active');
            });

            // Add the active class to the clicked tab
            this.classList.add('active');

            // Show the corresponding panel
            const panelId = this.getAttribute('href');
            const panel = document.querySelector(panelId);
            if (panel) {
                panel.style.display = 'block';
                panel.style.opacity = '0';
                let fadeEffect = setInterval(function () {
                    let opacity = parseFloat(panel.style.opacity);
                    if (!isNaN(opacity) && opacity < 1) {
                        panel.style.opacity = (opacity + 0.1).toString();
                    } else {
                        clearInterval(fadeEffect);
                    }
                }, 50);
            }
        });
    });

    // Trigger the first tab click programmatically
    if (tabs.length > 0) {
        tabs[0].click();
    }
});











